import React from 'react'
import Img from 'gatsby-image'
import InfoBlock from '../../shared/infoBlock'
import './hero.css'
import { Mobile, Default, isNarrowDesktop } from '../../../media-queries'

const Hero = props => (
  <div>
    <Default>
      <DefaultHero {...props} />
    </Default>
    <Mobile>
      <MobileHero {...props} />
    </Mobile>
  </div>
)

export default Hero

class DefaultHero extends React.Component {
  state = {
    height: getHeight(),
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateHeight)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateHeight)
    }
  }

  setHeight = () => {
    this.setState({ height: getHeight() })
  }

  updateHeight = () => {
    if (!isNarrowDesktop()) {
      this.setHeight()
    }
  }

  render() {
    return (
      <div style={this.props.style}>
        <Img
          style={{ height: this.state.height, minHeight: 600 }}
          sizes={this.props.image.sizes}
        />
        <InfoBlock
          style={{
            float: 'right',
            position: 'absolute',
            right: '4rem',
            bottom: '4rem',
            zIndex: 500,
            width: '55vw',
            background: 'white',
            padding: '1rem 2rem',
          }}
          title={this.props.title}
          text={this.props.text}
        />
      </div>
    )
  }
}

const getHeight = () => {
  if (window) {
    return window.innerHeight
  }
}

const MobileHero = props => (
  <div>
    <Img className="heroImage" sizes={props.image.sizes} />
    <InfoBlock
      style={{
        paddingTop: '3rem',
        marginLeft: '2rem',
        marginRight: '2rem',
      }}
      title={props.title}
      text={props.text}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/homepage/hero/index.js